import React from 'react'
import DataTable from 'react-data-table-component'
import { Link, useLocation, useNavigate } from 'react-router-dom'

export default function BlogDetail() {
    const navigate = useNavigate();
    const imageUrl = "./assets/images/";
    const location = useLocation();
    const handleBackClick = () => {
        navigate(-1);
    };
    const { content } = location.state || {}; // Access the passed content
    console.log(content, "content");
    const tagsString = content?.tags || ''; // Fallback to empty string if `content` or `tags` is undefined
    const tagsArray = tagsString.split(',').map(tag => tag.trim()); // Split and trim each tag

    return (
        <>
            <div className="title flex justify-start items-center mb-8 gap-4">
                <div className="bg-white py-3 px-4 rounded-[6px] shadow pointer" onClick={handleBackClick}>
                    <img src={imageUrl + "back.svg"} alt="" />
                </div>
                <h2>Blog Details</h2>
            </div>
            <div className="data-box overflow-auto responsive-table">
                <div className="p-6">
                    <div className="content-box">
                        <h4 className='text-xl Sora_SB border-b-2 border-[#E57549] w-min pb-3'>Title</h4>
                        <p className='pt-4 '>{content?.blog_title}</p>
                    </div>
                    <div className="content-box my-10 blog-detail-content">
                        <h4 className='text-xl Sora_SB border-b-2 border-[#E57549] w-min pb-3'>Content</h4>
                        <div className='description mt-6' dangerouslySetInnerHTML={{ __html: content?.content }}></div>

                    </div>
                    <div className="content-box my-10">
                        <h4 className='text-xl Sora_SB border-b-2 border-[#E57549] w-min pb-3'>Category</h4>
                        <p className='pt-4 text-[#666666]'>{content?.category?.name}</p>

                    </div>
                    <div className="content-box my-10">
                        <h4 className='text-xl Sora_SB border-b-2 border-[#E57549] w-min pb-3'>Tags</h4>
                        <ul className="tag-item pt-5 flex gap-5 mt-0 items-center">
                            {tagsArray.map((tag, index) => (
                                <li className='border border-[#E57549] rounded-[3px] px-3 py-1 primary-txt' key={index}>{tag}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="content-box my-10">
                        <h4 className='text-xl Sora_SB border-b-2 border-[#E57549] w-max pb-3'>Banner Image</h4>
                        <div className="pt-6 img-container">
                            <img src={content?.banner_image} alt="" width="200px" />
                        </div>
                    </div>
                    <div className="content-box my-10">
                        <h4 className='text-xl Sora_SB border-b-2 border-[#E57549] w-max pb-3'>Thumbnail Image</h4>
                        <div className="pt-6 img-container">
                            <img src={content?.thumbnail_image} alt="" width="200px" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
